/**
 * resizeController({
 *     767: {
 *         onMatch() {},   // ширина <= 767px
 *         onUnmatch() {}, // ширина > 767px
 *     },
 *     "(min-width: 1200px)": {
 *         onMatch() {},
 *     },
 * });
 *
 * Старая сигнатура тоже работает: resizeController(767, onMatch, onUnmatch)
 * Возвращает функцию, снимающую все подписки.
 */

function watchBreakpoint(size, { onMatch, onUnmatch } = {}) {
    const query = /^\d+$/.test(size) ? `all and (max-width: ${size}px)` : String(size);
    const mql = window.matchMedia(query);

    const checkMatches = (e) => {
        if (e.matches) {
            if (typeof onMatch === "function") onMatch(e);
        } else {
            if (typeof onUnmatch === "function") onUnmatch(e);
        }
    };

    checkMatches(mql);
    mql.addEventListener("change", checkMatches);

    return () => mql.removeEventListener("change", checkMatches);
}
export function resizeController(breakpoints, onMatch, onUnmatch) {
    if (typeof breakpoints !== "object" || breakpoints === null) {
        return watchBreakpoint(breakpoints, { onMatch, onUnmatch });
    }

    const destroyers = Object.entries(breakpoints).map(([size, handlers]) => watchBreakpoint(size, handlers));

    return () => destroyers.forEach((destroy) => destroy());
}
